import { render, staticRenderFns } from "./SnsFiles.vue?vue&type=template&id=ec79f81e&scoped=true&"
import script from "./SnsFiles.vue?vue&type=script&lang=js&"
export * from "./SnsFiles.vue?vue&type=script&lang=js&"
import style0 from "./SnsFiles.vue?vue&type=style&index=0&id=ec79f81e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec79f81e",
  null
  
)

export default component.exports